import DisplayContainer from './displayContainer'
import AssetHelper from "../AssetHelper";
import {initSounds} from "../sounds";
import {preloadVideos} from "./components/MatchVideo";
import DisplayParams from './DisplayParams';
import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

function BaseDisplay() {
    const [displayParams, setDisplayParams] = useState(window.displayParams);
    useEffect(() => {
        document.title = `${displayParams.eventCode} - Display`
        window.history.replaceState(displayParams, '')
    }, [displayParams]);
    useEffect(() => {
        addEventListener("popstate", (evt) => {
            setDisplayParams(evt.state);
        })
    }, []);

    return <DisplayParams.Provider value={displayParams}>
        <DisplayContainer reconfigure={setDisplayParams}/>
    </DisplayParams.Provider>;
}

// useAsset already handles ensuring this is loaded, but to allow preloading a/v clips it's much easier to
// not be forced to work with async apis
AssetHelper.ensureProperties().then(() => {
    initSounds();
    preloadVideos();

    const target = document.getElementById('displayRoot');
    if(!target) {
        throw "Target element for display not found"
    }
    const root = createRoot(target);
    root.render(<BaseDisplay />);
})
